/**
 * Created by Alex on 05/29/2023.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';

import { NotificationService } from '../../tamalelibs/services/notification.service';
import { NotificationModel } from '../../tamalelibs/models/notification.model';
import { NotificationActionTypes } from '../actions/notification.actions';

@Injectable()
export class NotificationEffects {

    constructor(
        private _actions$: Actions,
        private _notificationService: NotificationService,
    ) { }

    getNotificationEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(NotificationActionTypes.GETNOTIFICATIONS),
        switchMap(() => {
            return this._notificationService.getNotifications().pipe(
                map(response => response['reminderList']),
                map(response => {
                    const notificationList = response.map(element => NotificationModel.parse(element));
                    return {
                        type: NotificationActionTypes.GETNOTIFICATIONS_SUCCESS,
                        payload: notificationList
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: NotificationActionTypes.GETNOTIFICATIONS_FAILED,
                payload: err.message
            });
        })
    ));

    createNotificationEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(NotificationActionTypes.CREATENOTIFICATIONS),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._notificationService.createNotifications(payload.data)
            .pipe(
                map(response => ({
                    type: NotificationActionTypes.CREATENOTIFICATIONS_SUCCESS,
                    payload: {
                        newEntity: response,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return of({
                        type: NotificationActionTypes.CREATENOTIFICATIONS_FAILED,
                        payload: err.message
                    });
                })
            )
        )
    ));

    updateNotificationEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(NotificationActionTypes.EDITNOTIFICATIONS),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._notificationService.updateNotifications(payload.data)
            .pipe(
                map(response => ({
                    type: NotificationActionTypes.EDITNOTIFICATIONS_SUCCESS,
                    payload: {
                        newEntity: response,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return of({
                        type: NotificationActionTypes.EDITNOTIFICATIONS_FAILED,
                        payload: err.message
                    });
                })
            )
        )
    ));
}
